module.exports = __webpack_public_path__ + "img/julia-alvarez.a6f91ab6.png";